<script setup lang="ts">
import { watch } from 'vue';
import { orgManageApi } from '@/api';
import { City } from '@/api/modules/org';

defineOptions({
  inheritAttrs: true,
});

const props = defineProps<{
  modelValue: any;
  province: { provinceId: string; provinceName: string };
  city: string;
}>();
const emit = defineEmits(['update:city']);

const list = ref<City[]>([]);
const fullList = computed(() => {
  if (props?.city) {
    const hasOrg = list.value.find(item => item.name === props.city);
    if (hasOrg) {
      return list.value;
    } else {
      return [{ name: props.city }, ...list.value];
    }
  }
  return list.value;
});
const getCityData = () => {
  if (!props.province?.provinceId) return;
  orgManageApi.getCityList({ provinceId: props.province?.provinceId }).then(res => {
    list.value = res[0]?.city ?? [];
  });
};

watch(
  () => props.province,
  () => {
    // emit('update:city', '');
    getCityData();
  }
);
</script>
<template>
  <el-select
    :model-value="props.city"
    @change="emit('update:city', $event)"
    placeholder="请选择省份"
    filterable
    value-key="city"
  >
    <el-option v-for="item in fullList" :key="item.name" :label="item.name" :value="item.name" />
  </el-select>
</template>
